/* eslint-disable */
import { createStore } from "vuex";
import User from './User'
import Voucher from './Voucher'
import Category from './Category'
import Certificate from './Certificate'
import Transaction from './Transaction'
import Classroom from './Classroom'
import WebinarRecord from './WebinarRecord'
import Video from './Video'
import Modul from './Modul'
import Webinar from './Webinar'
import Quiz from './Quiz'
import Coupon from './Coupon'
import WebinarQuiz from './WebinarQuiz'
import Review from './Review'
import Task from './Task'
import Mentor from './Mentor'
import PromotionNotification from './PromotionNotification'
import Recommendation from './Recommendation'
import Admin from './Admin'
import Hot from './Hot'
import ClassroomTest from './ClassroomTest'
import Room from './Room'
import WebinarPlus from './WebinarPlus'
import Material from './Material'
import WebinarPackage from "./WebinarPackage"
import PrivateWebinar from "./PrivateWebinar"

export const store = createStore({
    modules: {
        User,
        Voucher,
        Category,
        Certificate,
        Transaction,
        Classroom,
        WebinarRecord,
        Video,
        Modul,
        Webinar,
        Quiz,
        Coupon,
        WebinarQuiz,
        Review,
        Task,
        PromotionNotification,
        Mentor,
        Recommendation,
        Admin,
        Hot,
        ClassroomTest,
        Room,
        WebinarPlus,
        Material,
        WebinarPackage,
        PrivateWebinar,
    }
});

// export {
//     state
// }